import React from 'react';
import { Chip, Stack, Typography } from '@mui/material';
import { unitFilterDisplayStyles } from './styles';
import { SPACING } from '../../styles';

interface UnitFilterDisplayProps {
  unitNames: ReadonlyArray<string>;
}

const UnitFilterDisplay: React.FC<UnitFilterDisplayProps> = React.memo(
  ({ unitNames }) => {
    if (unitNames.length === 0) {
      return null;
    }

    return (
      <Stack
        direction='row'
        spacing={SPACING.SMALL}
        alignItems='center'
        sx={unitFilterDisplayStyles}
      >
        <Typography variant='body2' color='text.secondary'>
          Filtering by units:
        </Typography>
        {unitNames.map((unitName) => (
          <Chip
            key={unitName}
            label={unitName}
            size='small'
            color='primary'
            variant='outlined'
          />
        ))}
      </Stack>
    );
  },
);

UnitFilterDisplay.displayName = 'UnitFilterDisplay';

export default UnitFilterDisplay;
